export const orderState = Symbol();
export const cartState = Symbol();
export const checkoutState = Symbol();
